// src/components/CustomerSummary/Constants/default.js

import SECTION_KEYS from './sectionKeys.js';

export const DEFAULT_ORDER = [...SECTION_KEYS];
export const DEFAULT_SECTION_ORDER = DEFAULT_ORDER;

export function buildEmptySections() {
  return SECTION_KEYS.reduce((a, k) => ({ ...a, [k]: '' }), {});
}
export function buildDefaultLocks() {
  return SECTION_KEYS.reduce((a, k) => ({ ...a, [k]: false }), {});
}
export function buildDefaultExpanded() {
  return SECTION_KEYS.reduce((a, k) => ({ ...a, [k]: true }), {});
}
